import Dispatcher from './components/Dispatcher.vue';
import Cropmecustomer from './components/Cropmecustomer.vue';
import Uploadcover from './components/Uploadcover.vue';
import Cropmecustomervorgang from './components/Cropmecustomervorgang.vue';
import Cropmedispatcher from './components/Cropmedispatcher.vue';
import Statistik from './components/public/Statistik.vue';
import Uploadseinzel from './components/public/Uploadseinzel.vue';
import About from './components/public/About.vue';
import MithelfenWhatsapp from './components/public/MithelfenWhatsapp.vue';
import MithelfenTelegram from './components/public/MithelfenTelegram.vue';
import BildFehler from './components/public/BildFehler.vue';
import Login from './components/Login.vue';
import Admin from './components/Admin.vue';

export const routes =  [
  {
    // Root-Pfad
    path: '',
    // component: Home
    redirect: '/public/about'
  },
  {
    path: '/dispatcher',
    component: Dispatcher,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }
  },
  {
    path: '/cropme',
    component: Cropmedispatcher,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }

  },
  {
    path: '/cropme/:customer',
    component: Cropmecustomer,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }

  },
  {
    path: '/uploadcover',
    component: Uploadcover,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }
  },
  {
    path: '/cropme/:customer/vorgang/:vorgang',
    component: Cropmecustomervorgang,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }
  },
  {
    path: '/admin',
    component: Admin,
    // guard: nur erlaubt wenn User ein Token hat
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('access_token')) {
        next();
      } else {
        next({ path: '/login' })
      }    
    }
  },
  {
    path: '/login',
    component: Login
  },
  {
    // das darf jeder sehen
    path: '/public',
    redirect: '/public/about'
  },
  {
    // das darf jeder sehen
    path: '/public/about',
    component: About
  },
  {
    // das darf jeder sehen
    path: '/public/mithelfen',
    redirect: '/public/mithelfen/whatsapp'
  },
  {
    // das darf jeder sehen
    path: '/public/mithelfen/whatsapp',
    component: MithelfenWhatsapp
  },
  {
    // das darf jeder sehen
    path: '/public/mithelfen/telegram',
    component: MithelfenTelegram
  },
  {
    // das darf jeder sehen
    path: '/public/mithelfen/bildfehler',
    component: BildFehler
  },
  {
    // das darf jeder sehen
    path: '/public/statistik',
    component: Statistik
  },
  {
    // das darf jeder sehen
    path: '/public/statistik/:uploader',
    component: Uploadseinzel
  }
];
